export const translations = {
  fr: {
    nav: { home: "Accueil", offers: "Offres", live: "Live", podcast: "Podcast", about: "À propos" },
    cta: {
      whatsapp: "Parler sur WhatsApp",
      schedule: "Planifier un appel",
      readMore: "Lire l'article",
      close: "Fermer",
    },
    hero: {
      eyebrowLine1: "ENTREPRENDRE EN FRANCE",
      eyebrowLine2: "SANS SE PRENDRE LA TÊTE",
      titleLines: ["On vous aide à", "créer votre entreprise", "en France et à la", "faire grandir."],
      highlightWords: ["créer", "grandir"],
      subtitle: "Du projet au chiffre d'affaires. Vous n'êtes pas seul.",
      badges: ["En français et en portugais", "Suivi personnalisé", "Focus résultats"],
      flagLine: "Brésil + France = Plus de possibilités",
      stickerTop: "MÊME TALENT.\nNOUVEAUX HORIZONS.",
      stickerBottom: "Plus d'opportunités,\nplus de liberté",
    },
    process: {
      eyebrow: "NOTRE MÉTHODE",
      title: "Un chemin clair, chapitre par chapitre.",
      steps: [
        { num: "01", title: "Créer", desc: "votre entreprise en France" },
        { num: "02", title: "Organiser", desc: "vos obligations" },
        { num: "03", title: "Résoudre", desc: "vos problèmes" },
        { num: "04", title: "Grandir", desc: "votre activité" },
      ],
    },
    offers: {
      eyebrow: "NOS OFFRES",
      title: "Choisissez votre façon d'avancer",
      mockToast: "Bientôt disponible ! Contactez-nous sur WhatsApp pour réserver votre accès.",
      items: [
        { tag: "PACK DIGITAL", name: "Vidéos + Mémo", desc: "Tout ce dont vous avez besoin pour démarrer, à votre rythme.", price: "39€", cta: "Acheter maintenant" },
        { tag: "LIVE", name: "Live pour apprendre à grandir", desc: "Sujets pratiques, cas réels et vos questions en direct.", price: "29€ par personne", cta: "Voir les prochains lives" },
        { tag: "CONVERSATION 1:1", name: "Consultation personnalisée", desc: "Posez vos questions et obtenez des conseils pour votre cas.", price: "50€ / 30 min", cta: "Planifier une conversation" },
      ],
    },
    marquee: "BRÉSIL + FRANCE = PLUS DE POSSIBILITÉS ♡ ENTREPRENDRE SANS STRESS ♡ BRING ME CASH ♡ ",
    blog: {
      eyebrow: "BLOG",
      title: "Idées et guides pratiques",
      subtitle: "Du contenu pour entreprendre en France avec plus de clarté.",
      empty: "Nouveaux articles bientôt disponibles.",
    },
    podcast: {
      eyebrow: "PODCAST",
      title: "Des histoires vraies, sans filtre",
      subtitle: "Des entrepreneurs brésiliens en France racontent tout.",
      empty: "Nouveaux épisodes bientôt disponibles.",
      mockToast: "Écoute bientôt disponible ! Abonnez-vous sur WhatsApp pour être averti.",
    },
    events: {
      eyebrow: "PROCHAINS ÉVÉNEMENTS",
      title: "Lives et masterclasses",
      subtitle: "Participez en direct et posez vos questions en temps réel.",
      cta: "Participer",
      spotsLabel: "places disponibles",
      empty: "Nouveaux événements bientôt disponibles.",
      payCta: "Payer et confirmer ma place",
    },
    finalCta: {
      title: "On discute ?",
      subtitle: "Faites le prochain pas pour votre entreprise. Parlez-nous sur WhatsApp ou planifiez un appel.",
      whatsapp: "Parler sur WhatsApp",
      schedule: "Planifier un appel",
    },
    footer: {
      tagline: "Entrepreneuriat sans frontières.",
      legal: ["Mentions légales", "CGV", "Politique de confidentialité"],
      rights: "Tous droits réservés.",
    },
  },
  pt: {
    nav: { home: "Início", offers: "Ofertas", live: "Live", podcast: "Podcast", about: "Sobre" },
    cta: {
      whatsapp: "Falar no WhatsApp",
      schedule: "Agendar uma conversa",
      readMore: "Ler artigo",
      close: "Fechar",
    },
    hero: {
      eyebrowLine1: "EMPREENDER NA FRANÇA",
      eyebrowLine2: "SEM DOR DE CABEÇA",
      titleLines: ["A gente ajuda você a", "criar sua empresa", "na França e fazer", "ela crescer."],
      highlightWords: ["criar", "crescer"],
      subtitle: "Do projeto ao faturamento. Você não está sozinho.",
      badges: ["Em português e francês", "Acompanhamento personalizado", "Foco em resultados"],
      flagLine: "Brasil + França = Mais possibilidades",
      stickerTop: "MESMO TALENTO.\nNOVOS HORIZONTES.",
      stickerBottom: "Mais negócios,\nmais liberdade",
    },
    process: {
      eyebrow: "NOSSO MÉTODO",
      title: "Um caminho claro, capítulo por capítulo.",
      steps: [
        { num: "01", title: "Criar", desc: "sua empresa na França" },
        { num: "02", title: "Organizar", desc: "suas obrigações" },
        { num: "03", title: "Resolver", desc: "seus problemas" },
        { num: "04", title: "Crescer", desc: "seu negócio" },
      ],
    },
    offers: {
      eyebrow: "NOSSAS OFERTAS",
      title: "Escolha a sua forma de avançar",
      mockToast: "Em breve! Fale com a gente no WhatsApp para garantir seu acesso.",
      items: [
        { tag: "PACK DIGITAL", name: "Vídeos + Mémo", desc: "Tudo o que você precisa para começar, no seu ritmo.", price: "39€", cta: "Comprar agora" },
        { tag: "LIVE", name: "Live para aprender a crescer", desc: "Temas práticos, cases reais e suas perguntas ao vivo.", price: "29€ por pessoa", cta: "Ver próximos lives" },
        { tag: "CONVERSA 1:1", name: "Consultoria personalizada", desc: "Tire suas dúvidas e receba orientação para o seu caso.", price: "50€ / 30 min", cta: "Agendar uma conversa" },
      ],
    },
    marquee: "BRASIL + FRANÇA = MAIS POSSIBILIDADES ♡ EMPREENDER SEM ESTRESSE ♡ BRING ME CASH ♡ ",
    blog: {
      eyebrow: "BLOG",
      title: "Ideias e guias práticos",
      subtitle: "Conteúdo para te ajudar a empreender na França com mais clareza.",
      empty: "Novos artigos em breve.",
    },
    podcast: {
      eyebrow: "PODCAST",
      title: "Histórias reais, sem filtro",
      subtitle: "Empreendedores brasileiros na França contam tudo.",
      empty: "Novos episódios em breve.",
      mockToast: "Escuta em breve! Assine no WhatsApp para ser avisado.",
    },
    events: {
      eyebrow: "PRÓXIMOS EVENTOS",
      title: "Lives e masterclasses",
      subtitle: "Participe ao vivo e tire suas dúvidas em tempo real.",
      cta: "Participar",
      spotsLabel: "vagas disponíveis",
      empty: "Novos eventos em breve.",
      payCta: "Pagar e confirmar presença",
    },
    finalCta: {
      title: "Vamos conversar?",
      subtitle: "Dê o próximo passo para o seu negócio. Fale com a gente no WhatsApp ou agende uma conversa.",
      whatsapp: "Falar no WhatsApp",
      schedule: "Agendar uma conversa",
    },
    footer: {
      tagline: "Empreendedorismo sem fronteiras.",
      legal: ["Termos legais", "CGV", "Política de privacidade"],
      rights: "Todos os direitos reservados.",
    },
  },
};
